var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-float top right",class:{'comment-mode': _vm.commentMode, 'countdown': _vm.countdown},style:(_vm.style),on:{"click":_vm.click}},[_c('span',{staticClass:"counter",attrs:{"id":"counter"}}),_c('i',{staticClass:"mdi mdi-close"})])
}
var staticRenderFns = []

export { render, staticRenderFns }